import React from 'react';
import { XIcon } from 'lucide-react';
import { handoffs, noMores, simpleMessages } from '../data/content';
import { CtaButton } from './CtaButton';
import { PrintCutShare } from './PrintCutShare';
const tones = ['text-navy', 'text-coral', 'text-navy', 'text-leaf-deep'];
export function SolutionIntro() {
  return <section aria-labelledby="solution-title" className="bg-cream" data-id="element-318" data-mp="3qe8zspa3jifu">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-319" data-mp="hxnm4v6is16e">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-320" data-mp="hv9w50qp5f5p">
          <div data-id="element-321" data-mp="lxod1fat24uc">
            <h2 id="solution-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-322" data-mp="ly6fwurz3hb8">
              Et si vous aviez un moyen simple de commencer ?
            </h2>
            <ul className="mt-8 space-y-2" data-id="element-323" data-mp="cwgfx0k0za1u">
              {simpleMessages.map((m, i) => <li key={m} className={`font-display text-2xl leading-snug sm:text-[30px] ${tones[i]}`} data-id="element-324" data-mp="2so48ykvx4ifd" data-mpi={i}>
                  {m}
                </li>)}
            </ul>
          </div>
          <div className="lg:pt-4" data-id="element-325" data-mp="2xafutsey2eff">
            <p className="text-lg font-bold text-navy" data-id="element-326" data-mp="2t8c8u9unfrfw">Quelque chose d’assez simple pour…</p>
            <ul className="mt-5 divide-y divide-cream-line border-y border-cream-line" data-id="element-327" data-mp="2taovv1f9krzt">
              {handoffs.map(h => <li key={h} className="py-3.5 text-lg text-ink-soft" data-id="element-328" data-mp="328hf2go3wjsh">
                  {h}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-20 max-w-3xl text-center" data-id="element-329" data-mp="3c76nliu44rw2">
          <p className="font-display text-3xl leading-tight text-navy sm:text-4xl" data-id="element-330" data-mp="3c6orqnbd4foo">C’est pour cela que le Pack Complet d’Évangélisation a été créé.</p>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-331" data-mp="3kzs0iib2c4cz">
            Une collection complète de <strong className="text-navy" data-id="element-332" data-mp="3r52dzdtbhew">200+ versets bibliques</strong> répartis sur{' '}
            <strong className="text-navy" data-id="element-333" data-mp="3uxo9p4kfwp8g">20+ modèles imprimables différents</strong>, conçus pour aider les chrétiens ordinaires à commencer à
            partager la Parole de Dieu de façon simple, pratique et créative.
          </p>
          <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-334" data-mp="avmravpsxji2">
            {noMores.map(n => <li key={n} className="inline-flex max-w-full items-center gap-2 rounded-[22px] bg-white px-4 py-2 font-semibold text-ink-soft shadow-card" data-id="element-335" data-mp="fsmumyv9o85h">
                <XIcon className="h-4 w-4 shrink-0 text-coral" strokeWidth={3} aria-hidden="true" data-id="element-336" data-mp="pjhjmazwdlum" />
                <span className="text-balance text-left leading-snug" style={{
              textAlign: "center",
              fontSize: "14px"
            }} data-id="element-337" data-mp="tl2rfhxkr9xy">{n}</span>
              </li>)}
          </ul>
          <p className="mt-10 font-display text-2xl italic text-ink-soft" data-id="element-338" data-mp="yi2xhsufccp2">Il vous suffit de…</p>
          <div className="mt-3" data-id="element-339" data-mp="13h659l1sgx0q">
            <PrintCutShare data-id="element-340" data-mp="30bsiepilakvj" />
          </div>
          <p className="mt-3 font-display text-2xl text-leaf-deep" data-id="element-341" data-mp="30d3len47noll">Et de commencer à semer.</p>
          <CtaButton className="mt-8" data-id="element-342" data-mp="35bew102by34v">Accéder maintenant</CtaButton>
        </div>
      </div>
    </section>;
}